import React from 'react'
import { useDispatch } from 'react-redux'
import { IOnboardingExternalGMS, ShopExternalGMS } from '@cbgms/api'
import { createShopExternalGMS, getShopExternalGMS } from '@cbgms/api/modules/shops/external-gms/requests'
import useQuery, { UseMutationOptions, useMutation } from '@cbgms/base/http/use-query'
import { onboardingExternalGMSList } from 'app/auth/state/actions'

const CACHEKEY_LIST = ['ONBOARDING', 'EXTERNAL-GMS-LIST']
const CACHEKEY_SHOP = ['ONBOARDING', 'EXTERNAL-GMS-SHOP']

export const useFindGMSWithNonOption = (externalGMSs: IOnboardingExternalGMS[]) =>
  React.useMemo(() => {
    const initial = externalGMSs.find(gms => gms.IsNone)
    if (initial) {
      return {
        UUID: initial.UUID,
        HasRemark: initial.HasRemark,
        Name: ''
      }
    }
    return undefined
  }, [externalGMSs])

export const useGetExternalGMS = () => {
  const dispatch = useDispatch()

  return useQuery(
    CACHEKEY_LIST,
    async () => {
      return (await dispatch(onboardingExternalGMSList())).Data
    },
    { refetchOnWindowFocus: false }
  )
}
export const useGetShopExternalGMS = () => {
  const dispatch = useDispatch()

  return useQuery(CACHEKEY_SHOP, async () => {
    return (await dispatch(getShopExternalGMS())).Data
  })
}
export const useUpdateExternalGMS = (options?: UseMutationOptions<void, unknown, ShopExternalGMS, unknown> | undefined) => {
  const dispatch = useDispatch()

  return useMutation(async ({ ExternalGMSUUID, Remark }) => {
    await dispatch(createShopExternalGMS({ ExternalGMSUUID, Remark }))
  }, options)
}
